import React, { useEffect, useState } from "react";
import "jsvectormap/dist/maps/world.js";
import "jsvectormap/dist/css/jsvectormap.min.css";
import {
  Card,
  CardBody,
  CardExpandToggler,
} from "./../components/card/card.jsx";
import { useDispatch, useSelector } from "react-redux";
import { getRoleList, getRolePage } from "../redux/action/roleAction.js";
import { getRoleModuleById, getRoleModulePage, updateRoleModul } from "../redux/action/roleModuleAction.js";
import "../assets/list.css";
import Wrapper from "../components/scrollbar/scrollBarComponent.jsx";
import ButtonComponent from "../components/ButtonComponent.jsx";
import { openForm } from "../redux/slice/roleSlice.js";
import FormRole from "./Role/FormRole.jsx";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import findItem from "../helperFindPath.js";
import FormDeleteRole from "../form-data-master/FormDeleteRole.jsx";

const CollapseContainer = styled.div`
  overflow: hidden;
  transition: max-height 0.3s ease, transform 0.3s ease; /* Tambahkan animasi untuk max-height dan transform */
  max-height: ${(props) => (props.isOpen ? '1000px' : '0')}; /* Atur nilai maksimum tinggi untuk animasi collapse */
  transform: translateY(${(props) => (props.isOpen ? '0' : '-100%')}); /* Geser elemen ke atas saat ditutup */
`;

const CollapseContent = styled.div`
  padding: 10px 0px ;
`;

function RoleModule() {
  const [newModuleType, setNewModuleType] = useState('')
  const [modulParent, setModulParent] = useState('')
  const [modulChildren, setModulChildren] = useState('')
  const [activityLogData, setActivityLogData] = useState();
  const dispatch = useDispatch();
  const [activeItem, setActiveItem] = useState(null);
  const [toggleAddModul, setToggleAddModule] = useState(false);
  const [collapsedRows, setCollapsedRows] = useState([]);
  const [selectedRole, setSelectedRole] = useState();
  const { dataRoleList, isOpenRole, isLoading, state } = useSelector(
    (state) => state.role
  );
  const { dataRoleModule, isOpenRoleModule } = useSelector(
    (state) => state.roleModule
  );
  const [checklist, setCheckList] = useState([])
  const { user } = useSelector((state) => state.auth);
  const param = {
    token: user.access_token,
  }
  const openAddModul = () =>{
    setToggleAddModule(!toggleAddModul);
  }
  const toggleRow = (index) => {
    // console.log(collapsedRows.includes(index));
    // console.log(collapsedRows);
    if (collapsedRows.includes(index)) {
      setCollapsedRows(collapsedRows.filter((rowIndex) => rowIndex !== index));
    } else {
      setCollapsedRows([...collapsedRows, index]);
    }
  };

  const handleItemClick = (index) => {
    setActiveItem(index);
  };
  const postToAPI = (modulId,id, condition, state) =>{
    // console.log(id)
    let body = {
      modulId : modulId,
      roleId : selectedRole,
    }
    if(state === 'create'){
      body.create = condition
    }
    if(state === 'read'){
      body.read = condition
    }
    if(state === 'update'){
      body.update = condition
    }
    if(state === 'delete'){
      body.delete = condition
    }
    dispatch(updateRoleModul({id: id, data: body, token: user.access_token }))
  }
  const handleCheckboxChange = (parentIndex, childIndex, property) => {
    setCheckList((prevChecklist) => {
      const newArr = prevChecklist.map((parentItem, pIndex) => {
        if (pIndex !== parentIndex) return parentItem;
  
        if (childIndex !== null) {
          // Update checkbox for subModul
          return {
            ...parentItem,
            subModul: parentItem.subModul.map((childItem, cIndex) => {
              if (cIndex !== childIndex) return childItem;
              return { ...childItem, [property]: !childItem[property] };
            }),
          };
        }
  
        // Update checkbox for main module
        return { ...parentItem, [property]: !parentItem[property] };
      });
  
      return newArr;
    });
  
    // Lakukan pemanggilan API atau operasi lain yang diperlukan di sini
    const itemToUpdate = childIndex !== null
      ? checklist[parentIndex].subModul[childIndex]
      : checklist[parentIndex];
    
    const stateToUpdate = property === 'create' ? !itemToUpdate.create : itemToUpdate[property];
    postToAPI(itemToUpdate.modulId, itemToUpdate.id, stateToUpdate, property);
  };

  useEffect(() => {
    dispatch(getRoleList(param));
    // eslint-disable-next-line
  }, []);
  useEffect(()=> {
    if(dataRoleModule.length > 0){
      let arr = []
      dataRoleModule.map((key,index)=>{
        arr.push(key)
      })
      // console.log(arr)
      setCheckList(arr)
    }
  },[dataRoleModule])

  const {dataRoleModuleSidebar, dataByIdRoleModule} = useSelector((state)=>state.roleModule)
  const { pathname } = useLocation();
  const [ dataObjPath, setDataObjPath] = useState('')
  useEffect(() => {
    if(dataObjPath !== ''){
      param.id = dataObjPath.id
      dispatch(getRoleModuleById(param))
    }
    // eslint-disable-next-line
  }, [dataObjPath]);
  useEffect(()=>{
    if(dataRoleModuleSidebar.length > 0){
      const findPath = findItem(dataRoleModuleSidebar, pathname)
      if(findPath !== null){
        setDataObjPath(findPath) 
      }
    }
  },[dataRoleModuleSidebar])
  if(dataByIdRoleModule !== ''){

  if(!dataByIdRoleModule.create && !dataByIdRoleModule.read && !dataByIdRoleModule.update && !dataByIdRoleModule.delete){
    return (
      <div>
        <h2>403: Forbidden</h2>
        <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
      </div>
    )
  }else{
  return (
    <div>
      <div className="row" style={{ paddingTop: "15px" }}>
        <div className="col-xl-12">
          <Card className="mb-3">
            <CardBody>
              <div className="row">
                <div className="col-xl-3">
                  <div className="row">
                    <div className="col-xl-6" style={{ paddingBottom: "10px" }}>
                      <span style={{ fontSize: "1rem" }}>Role</span>
                    </div>
                    <div
                      className="col-xl-6"
                      style={{ paddingBottom: "10px", textAlign: "right" }}
                    >
                      {/* {dataByIdRoleModule.create ? (
                          <ButtonComponent
                          onClick={() =>
                            dispatch(openForm({ open: true, state: "add" }))
                          }
                          color="white"
                          backgroundColor="#3003fc"
                          backgroundHover="#2404b5"
                        >
                          + Tambah
                        </ButtonComponent>
                      ): null} */}
                    </div>
                  </div>
                </div>
                <div className="col-xl-9">
                  <div className="row">
                    <div className="col-xl-6" style={{alignSelf: 'center'}}>
                      <span style={{ fontSize: "1rem", alignSelf: "left" }}>
                        Module
                      </span>
                    </div>
                    {/* <div className="col-xl-6" style={{textAlign: 'right'}}>

                    {dataByIdRoleModule.create ? (
                      <ButtonComponent
                        onClick={() =>
                          openAddModul()
                        }
                        color="white"
                        backgroundColor="#3003fc"
                        backgroundHover="#2404b5"
                      >
                        + Tambah
                      </ButtonComponent>
                      ): null 
                    }
                    </div>
                    <div className="col-xl-12">
                      <CollapseContainer isOpen={toggleAddModul}>
                        <CollapseContent>
                          <Card style={{ maxHeight: 500}}>
                            <CardBody>
                              <div className="row">
                                  <div className={newModuleType === '' ? 'col-xl-12' : newModuleType === 'new' ? 'col-xl-6': newModuleType === 'exist' ? 'col-xl-4' : 'col-xl-12'}>

                                    <span style={{fontSize: 13}}>Tipe Modul</span>
                                    <select name="" id="type" className="form-control" value={newModuleType} onChange={(e)=>setNewModuleType(e.target.value)}>
                                      <option value="">-</option>
                                      <option value="new">Modul Baru</option>
                                      <option value="exist">Modul Eksis</option>
                                    </select>
                                  </div>
                                {newModuleType === 'new' ? (
                                  <>
                                    <div className="col-xl-6">

                                      <span style={{fontSize: 13}}>Modul Utama</span>
                                      <select name="" id="type" className="form-control" value={newModuleType} onChange={(e)=>setNewModuleType(e.target.value)}>
                                        <option value="">-</option>
                                        <option value="new">Modul Baru</option>
                                        <option value="exist">Modul Eksis</option>
                                      </select>
                                    </div>
                                    <div className="col-xl-6">
                                    </div>
                                  </>
                                ) : newModuleType === 'exist' ? (
                                  <>
                                    <div className="col-xl-4">
                                      <span style={{fontSize: 13}}>Modul Utama</span>
                                      <select name="" id="type" className="form-control" value={newModuleType} onChange={(e)=>setNewModuleType(e.target.value)}>
                                        <option value="">-</option>
                                        <option value="new">Modul Baru</option>
                                        <option value="exist">Modul Eksis</option>
                                      </select>
                                    </div>
                                  
                                    <div className="col-xl-4">
                                      <span style={{fontSize: 13}}>Modul Turunan</span>
                                      <select name="" id="type" className="form-control" value={newModuleType} onChange={(e)=>setNewModuleType(e.target.value)}>
                                        <option value="">-</option>
                                        <option value="new">Modul Baru</option>
                                        <option value="exist">Modul Eksis</option>
                                      </select>
                                    </div>
                                  </>
                                  ) : null
                                }
                              </div>
                            </CardBody>
                          </Card>
                        </CollapseContent>
                      </CollapseContainer>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="row">
                <div
                  className="col-xl-3 col-lg-3"
                  style={{ paddingRight: "10px" }}
                >
                  <Card style={{ maxHeight: 500}}>

                    <CardBody>
                      
                    {dataByIdRoleModule.read ? (                      
                      <div style={{maxHeight: 350, overflowY: 'scroll'}}><ul className="list">
                          {dataRoleList.map((item, index) => (
                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                <li
                                key={index}
                                className={index === activeItem ? "active" : ""}
                                // style={activeItem ? { backgroundColor: 'blue'} : null}
                                onClick={() => {
                                    handleItemClick(index);
                                    setSelectedRole(item.id)
                                    dispatch(getRoleModulePage({ roleId: item.id , token: param.token}));
                                }}
                                // onChange={(e) => }
                                style={{width: '100%', background: 
                                index === activeItem ? 'blue': 'transparent'}
                                }
                                >
                                {item.name}
                                </li>
                            </div>
                          ))}
                        </ul>

                      </div>
                    ): null}
                    </CardBody>
                  </Card>
                </div>
                <div className="col-xl-9 col-lg-9">
                  <Card className='mb-3'>
                    <CardBody>

                      
                    {dataByIdRoleModule.update ? (     
                        <div    
                          className="table-responsive"
                          style={{ paddingTop: "15px" }}
                        >
                          <Wrapper>
                            <table className="table table-borderless mb-2px small text-nowrap h-100%">
                              <thead>
                                <tr>
                                  <th style={{ width: "5%" }}></th>
                                  <th>Module</th>
                                  <th style={{ textAlign: "center" }}>Create</th>
                                  <th style={{ textAlign: "center" }}>Read</th>
                                  <th style={{ textAlign: "center" }}>Update</th>
                                  <th style={{ textAlign: "center" }}>Delete</th>
                                </tr>
                              </thead>
                              <tbody>
                                {checklist.map((row, index) => (
                                  <React.Fragment key={index}>
                                    {row.id !== null ? (
                                      <tr style={{ verticalAlign: "middle" }}>
                                        <td>
                                          {row.subModul > [] ? (
                                            <button
                                              className="btn"
                                              style={{
                                                background: "transparent",
                                              }}
                                              onClick={() => toggleRow(index)}
                                            >
                                              <i className="fa fa-arrow-right"></i>
                                            </button>
                                          ) : null}
                                        </td>
                                        <td>{row.name}</td>
                                        <td>
                                          <input
                                            type="checkbox"
                                            class="form-check-input"
                                            checked={row.create}
                                            onChange={(e)=>{
                                              setCheckList((prevChecklist) => {
                                                const newArr = prevChecklist.map((item, i) => {
                                                  if (i === index) {
                                                    return { ...item, create: !item.create };
                                                  }
                                                  return item;
                                                });
                                                return newArr;
                                              });
                                              postToAPI(row.modulId, row.id, !row.create, 'create')
                                            }}
                                            style={{ marginLeft: "40px" }}
                                          />
                                          {row.create}
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          <input
                                            type="checkbox"
                                            class="form-check-input"
                                            checked={row.read}
                                            onClick={(e)=>{
                                              setCheckList((prevChecklist) => {
                                              const newArr = prevChecklist.map((item, i) => {
                                                if (i === index) {
                                                  return { ...item, read: !item.read };
                                                }
                                                return item;
                                              });
                                                return newArr;
                                              });
                                              postToAPI(row.modulId, row.id, !row.read, 'read')
                                            }}
                                          />
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          <input
                                            type="checkbox"
                                            class="form-check-input"
                                            checked={row.update}
                                            onClick={(e)=>{
                                              setCheckList((prevChecklist) => {
                                              const newArr = prevChecklist.map((item, i) => {
                                                if (i === index) {
                                                  return { ...item, update: !item.update };
                                                }
                                                return item;
                                              });
                                                return newArr;
                                              });
                                              postToAPI(row.modulId, row.id, !row.update, 'update')
                                            }}
                                          />
                                        </td>
                                        <td style={{ textAlign: "center" }}>
                                          <input
                                            type="checkbox"
                                            class="form-check-input"
                                            checked={row.delete}
                                            onClick={(e)=>{
                                              setCheckList((prevChecklist) => {
                                              const newArr = prevChecklist.map((item, i) => {
                                                if (i === index) {
                                                  // console.log(item)
                                                  return { ...item, delete: !item.delete };
                                                }
                                                return item;
                                              });
                                                return newArr;
                                              });
                                              postToAPI(row.modulId, row.id, !row.delete, 'delete')
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    ) : null}

                                    {collapsedRows.includes(index) &&
                                      row.subModul.map(
                                        (dataChild, indexChild) => (
                                          <>
                                            {dataChild.id !== null ? (
                                              <tr className="child-row">
                                                <td></td>
                                                <td
                                                  style={{ paddingLeft: "20px" }}
                                                >
                                                  {dataChild.name}
                                                </td>
                                                <td
                                                  style={{ textAlign: "center" }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    checked={dataChild.create}
                                                    onChange={() => handleCheckboxChange(index, indexChild, 'create')}
                                                  />
                                                </td>
                                                <td
                                                  style={{ textAlign: "center" }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    checked={dataChild.read}
                                                    onChange={() => handleCheckboxChange(index, indexChild, 'read')}
                                                  />
                                                </td>
                                                <td
                                                  style={{ textAlign: "center" }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    checked={dataChild.update}
                                                    onChange={() => handleCheckboxChange(index, indexChild, 'update')}
                                                  />
                                                </td>
                                                <td
                                                  style={{ textAlign: "center" }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    checked={dataChild.delete}
                                                    onChange={() => handleCheckboxChange(index, indexChild, 'delete')}
                                                  />
                                                </td>
                                              </tr>
                                            ) : null}
                                          </>
                                        )
                                      )}
                                  </React.Fragment>
                                ))}
                              </tbody>
                            </table>
                          </Wrapper>
                        </div>
                      ): null
                    }
                    </CardBody>
                  </Card>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
      {state === 'delete' ? (
        <FormDeleteRole param={param} />
      ) : state === 'add' ? (
        <FormRole param={param}/>
      ) : null}
      
      
    </div>
  );
  }
  }
  return (
    <div>
      <h2>403: Forbidden</h2>
      <p>Anda Tidak Memiliki Hak Akses Untuk Halaman Ini</p>
    </div>
  )
}

export default RoleModule;
